import { AnyObject } from '@common/types/queryState';
import { isNullOrUndefined, isObject } from './typeGuards';

export const mergeWithDefault = <T>(
    source: Partial<T> | null | undefined,
    target: T,
): T => {
    if (!source) return target;

    const merged = { ...target };

    for (const key in source) {
        if (!Object.prototype.hasOwnProperty.call(source, key)) continue;

        const sourceValue = source[key];
        const targetValue = target[key];

        if (isNullOrUndefined(sourceValue)) continue;

        if (isObject(sourceValue) && isObject(targetValue)) {
            merged[key] = mergeWithDefault(
                sourceValue as AnyObject,
                targetValue as AnyObject,
            ) as T[Extract<keyof T, string>];
        } else {
            merged[key] = sourceValue as T[Extract<keyof T, string>];
        }
    }

    return merged;
};
